export default (state = {}, action) => {

    switch (action.type) {

        case 'GETTING_EVENTS':
            return Object.assign({},state,{ui: action.payload.ui})
        case 'GET_EVENTS_ERROR':
            return Object.assign({},state,{
                ui: action.payload.ui,
                message: action.payload.message
            })
        case 'GET_EVENTS_SUCCESS':
            return Object.assign({},state,{
                ui: action.payload.ui,
                events: action.payload.events
            })
        default:
            return state
    }
}
